import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { IChatRequestData } from '../../types/common';
import { getChatDataService, sendMessageService } from '../../api/chatApi';
import { IChatResponse, ISendMessageRequestData } from '../../types/api/chatApi';
import { ChatState } from '../../types/features/chatSlice';

export const getChatData = createAsyncThunk<IChatResponse, IChatRequestData>(
  'Chat/getChatData',
  async ({ user1, user2 }) => {
    const response = await getChatDataService({ user1, user2 });
    return response.data;
  }
);

export const sendMessageData = createAsyncThunk<IChatResponse, ISendMessageRequestData>(
  'Chat/sendMessageData',
  async (data) => {
    const response = await sendMessageService(data);
    return response.data;
  }
);

const ChatSlice = createSlice({
  name: 'Chat',
  initialState: {
    chatLoader: false,
    status: false,
    msg: '',
    data: null,
  } as ChatState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addCase(getChatData.pending, (state) => {
        state.chatLoader = true;
      })
      .addCase(getChatData.fulfilled, (state, action: PayloadAction<IChatResponse>) => {
        state.data = action.payload.data;
        state.msg = action.payload.message;
        state.status = true;
        state.chatLoader = false;
      })
      .addCase(getChatData.rejected, (state, action) => {
        state.chatLoader = false;
        state.status = false;
        state.msg = action.error.message;
      })
      .addCase(sendMessageData.pending, (state) => {
        state.chatLoader = true;
      })
      // .addCase(sendMessageData.fulfilled, (state, action: PayloadAction<IChatResponse>) => {
      //   let addMessage = JSON.parse(JSON.stringify(state.data));
      //   // addMessage.push(addMessage);
      //   state.data = addMessage;
      //   state.msg = action.payload.message;
      //   state.status = true;
      //   state.chatLoader = false;
      // })
      .addCase(sendMessageData.fulfilled, (state, action: PayloadAction<IChatResponse>) => {
        state.data = [...(state.data || []), ...(action.payload.data || [])];
        state.msg = action.payload.message;
        state.status = true;
        state.chatLoader = false;
      })
      .addCase(sendMessageData.rejected, (state, action) => {
        state.chatLoader = false;
        state.status = false;
        state.msg = action.error.message;
      })

  }
});

export default ChatSlice.reducer;
